import { useEffect } from "react";
import { Outlet } from "react-router";
import GlobalNotificationErrorSnackbar from "../../shared/components/GlobalNotificationErrorSnackbar";
import GlobalNotificationSnackbar from "../../shared/components/GlobalNotificationSnackbar";
import { NotificationContextProvider } from "../../shared/contexts/NotificationContextProvider";
import sharedBiClient from "../../shared/reporting/api/biClient";
import { GroupsContextProvider } from "../../shared/reporting/components/groups/contexts/GroupsContextProvider";
import { BiApiClientProvider } from "../../shared/reporting/contexts/BiApiClientProvider";
import biClient from "../api/biApi";
import { BiApiClient } from "../contexts/ApiClientProviderContext";
import { useClientContext } from "../contexts/ClientContext";
import { useLocalization } from "../hooks/useLocalization";
import useReportMode from "../hooks/useReportMode";
import { useAppDispatch } from "../store/hooks/useAppDispatch";
import { fieldsStateActions } from "../store/thunks/fieldStatesThunks";
import useReportGroups from "./builder/common/hooks/useReportGroups";
import { getEditReportUrl, getUiReportsUrl, getViewReportUrl } from "./builder/common/utilities/editReportUrl";
import ImportantDataLoadingFailed from "./common/ImportantDataLoadingFailed";

const ReportsContainer = () => {
  const { common: locale } = useLocalization();
  const { clientCode } = useClientContext();
  const { reportGroups, actions, ui } = useReportGroups({ reportUsage: "Ui" });
  const { mode } = useReportMode();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (mode === "run") {
      //The mode can be changed from edit to run, so we need to reset the fields state
      dispatch(fieldsStateActions.resetFieldsState());
    }
  }, [mode, dispatch]);

  if (ui.error) {
    return (
      <ImportantDataLoadingFailed
        title={locale.report_data_loading_failed_title}
        disclaimer={locale.report_data_loading_failed_text}
      />
    );
  }

  return (
    <BiApiClientProvider<BiApiClient>
      api={{
        ...biClient.uiReports,
        ...sharedBiClient.uiReports,
        getEditReportUrl,
        getViewReportUrl,
        getReportsUrl: getUiReportsUrl,
      }}
    >
      <GroupsContextProvider groups={{ [clientCode]: reportGroups }} ui={ui} actions={actions}>
        <NotificationContextProvider>
          <Outlet />
          <GlobalNotificationSnackbar />
          <GlobalNotificationErrorSnackbar />
        </NotificationContextProvider>
      </GroupsContextProvider>
    </BiApiClientProvider>
  );
};

export default ReportsContainer;
